import { createFileRoute } from '@tanstack/react-router';
import CorrectiveActions from 'src/pages/Organization/Branches/CorrectiveActions';

export const Route = createFileRoute(
  '/$organizationSlug/branches/$branchId/corrective_actions',
)({
  component: CorrectiveActions,
});
